<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div
  :class="[
      {'vs-sidebar-item-active'            : activeLink},
      {'disabled-item pointer-events-none' : isDisabled}
    ]"
  class="vs-sidebar--item">

  <router-link
    :class="[{'router-link-active': activeLink}]"
    :target="target"
    :to="to"
    tabin dex="-1"
    v-if="to">
    <vs-icon :icon="icon" :icon-pack="iconPack" v-if="!featherIcon"/>
    <feather-icon :class="{'w-3 h-3': iconSmall}" :icon="icon" v-else/>
    <slot/>
  </router-link>

  <a :href="href" :target="target" tabindex="-1" v-else>
    <vs-icon :icon="icon" :icon-pack="iconPack" v-if="!featherIcon"/>
    <feather-icon :class="{'w-3 h-3': iconSmall}" :icon="icon" v-else/>
    <slot/>
  </a>
</div>
</template>

<script>
export default {
  name: 'v-nav-menu-item',
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconSmall: {
      type: Boolean,
      default: false
    },
    iconPack: {
      type: String,
      default: 'material-icons'
    },
    href: {
      type: [String, null],
      default: '#'
    },
    to: {
      type: [String, Object, null],
      default: null
    },
    slug: {
      type: String,
      default: null
    },
    index: {
      type: [String, Number],
      default: null
    },
    featherIcon: {
      type: Boolean,
      default: true
    },
    target: {
      type: String,
      default: '_self'
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    activeLink () {
      return !!((this.to.name === this.$route.name || this.$route.meta.parent === this.slug) && this.to);
    }
  }
};

</script>

